import state from '~store/modules/onboarding/state'
import mutations from '~store/modules/onboarding/mutations'
import actions from '~store/modules/onboarding/actions'
import getters from '~store/modules/onboarding/getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
